import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-panel-title',
  templateUrl: './panel-title.component.html',
  styleUrls: ['./panel-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PanelTitleComponent {}
